import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Constants } from '../../../../../../common/Constants';
import {
  convertTimeToAmPm,
  filterNotEmptyHoursOfOperations,
  getUncommonElements,
  groupingClosingAndOpeningTime,
} from '../../../../../../utils/providerDetails.utils';
import { PrintViewBoldText } from '../../Print/BehavioralHealthFacilityPrintView';
import { PrintViewProviderDetailsXSText } from './PrintExpandedCardStyle.styled';

const processHoursData = (hoursData) => {
  if (!hoursData) {
    return [];
  }

  // Format 1: Array format
  if (Array.isArray(hoursData)) {
    return hoursData.map((item) => ({
      day: item?.day,
      openingTime: item?.openingTime || '',
      closingTime: item?.closingTime || '',
    }));
  }

  // Format 2: Object format
  if (typeof hoursData === 'object') {
    return Object.keys(hoursData).map((day) => {
      const timeString = hoursData[day];
      const times = timeString?.split(',') || [];

      return {
        day,
        openingTime: times[0]?.trim() || '',
        closingTime: times[1]?.trim() || '',
      };
    });
  }

  return [];
};

export const PrintHoursOfOperation = ({
  selectedProvider,
  not_available,
  isUsedInCompare = false,
}) => {
  const { t } = useTranslation();

  const opsHours = processHoursData(selectedProvider?.hoursOfOperation);

  const notEmptyHoursOfOperation = filterNotEmptyHoursOfOperations({
    ...selectedProvider,
    hoursOfOperation: opsHours,
  });

  const groupByClosingAndOpeningTime = groupingClosingAndOpeningTime(
    t,
    notEmptyHoursOfOperation
  );

  const notAvailableDays = getUncommonElements(
    Constants.ALL_DAYS,
    notEmptyHoursOfOperation.map((days) => days.day)
  );
  const translationOfNotAvailableDays = notAvailableDays.map((day) => t(day));
  return (
    <Layout.Group alignItems="top">
      {opsHours?.length ? (
        <React.Fragment>
          <Flex direction="column">
            {Object.keys(groupByClosingAndOpeningTime)?.map((open) => (
              <div key={`${open}`}>
                {Object.keys(groupByClosingAndOpeningTime[open])?.map(
                  (close) => (
                    <Flex
                      alignItems="center"
                      justify="flex-start"
                      key={`${open}-${close}`}
                    >
                      <PrintViewProviderDetailsXSText
                        css={{ marginBottom: isUsedInCompare ? '8px' : 0 }}
                      >
                        <PrintViewBoldText>
                          {' '}
                          {groupByClosingAndOpeningTime[open][close].map(
                            (days, index) =>
                              (index ? ', ' : '') + days?.slice(0, 2)
                          )}
                          :
                        </PrintViewBoldText>
                        {convertTimeToAmPm(open.slice(0, 5))} -{' '}
                        {convertTimeToAmPm(close.slice(0, 5))}
                      </PrintViewProviderDetailsXSText>
                    </Flex>
                  )
                )}
              </div>
            ))}

            {translationOfNotAvailableDays?.length > 0 && (
              <Flex alignItems="center" justify="flex-start">
                <PrintViewProviderDetailsXSText
                  css={{ marginBottom: isUsedInCompare ? '8px' : 0 }}
                >
                  <PrintViewBoldText>
                    {' '}
                    {translationOfNotAvailableDays?.map(
                      (DaysNotAvailable, index) =>
                        (index ? ', ' : '') + t(DaysNotAvailable?.slice(0, 2))
                    )}
                    :
                  </PrintViewBoldText>
                  {not_available}
                </PrintViewProviderDetailsXSText>
              </Flex>
            )}
          </Flex>
        </React.Fragment>
      ) : (
        <PrintViewProviderDetailsXSText>
          {not_available}
        </PrintViewProviderDetailsXSText>
      )}
    </Layout.Group>
  );
};
